import { SectionOption } from './types';

export const optionsLabelsAreString = (
  options: SectionOption[]
): options is ({ label: string } & Omit<SectionOption, 'label'>)[] =>
  options.every(({ label }) => typeof label === 'string');
